module OnlineDPR.Application.Client.Report.SidebarMenu

open Fable.React
open Fable.React.Props

open OnlineDPR.Application.Shared
open OnlineDPR.Application.Client.Report.Types
open OnlineDPR.Application.Client
open OnlineDPR.Application.Shared.Translations

let mutable private menuBound = false

let private getClassName entry (filter: ReportFilterViewModel) =
    if (entry.Level = filter.Level) &&  (entry.LevelIdentifier = filter.LevelIdentifier) then
        "mm-active"
    else
        ""

let private renderMenuEntryHeader entry filter dispatch =
    [a   [  Href "#"
            AriaExpanded false
            OnClick (fun ev -> dispatch (UpdateFilter { filter with LevelIdentifier = entry.LevelIdentifier
                                                                    Level = entry.Level} ))
            ClassName (getClassName entry filter)
            ]
            (match entry.SubEntries.Length with
                    | 0 -> [ str entry.Name ]
                    | _ -> [ str entry.Name
                             i   [   ClassName "fa arrow" ] [] ])]

let rec private renderSidebarMenuEntry entry filter dispatch =
    li  []
        (List.concat    [   (renderMenuEntryHeader entry filter dispatch)
                            (match entry.SubEntries.Length with
                            | 0 -> []
                            | _ -> [ ul  [  ClassName "sidebar-nav"
                                            AriaExpanded false]
                                            (entry.SubEntries
                                            |> List.map (fun subentry -> renderSidebarMenuEntry subentry filter dispatch)) ])])

let renderSidebar model dispatch =
    [   li  [   ClassName "mm-active" ]
            [   a   [   Href "#"
                        AriaExpanded true   ]
                    [   i  [    ClassName "far fa-chart-bar" ] [ ]
                        str CurrentTranslations.Translations.[TranslationKey.Dpr_Title ]
                        i   [   ClassName "fa arrow" ] [] ]
                ul  [   ClassName "sidebar-nav" ]  [ renderSidebarMenuEntry model.Menu model.Filter dispatch ]]
        li  [   Ref (fun _ -> match not (List.isEmpty model.Menu.SubEntries) && not menuBound with
                                | true ->   menuBound <- true
                                            dispatch BindMenu
                                | false -> ())] []
    ]